<template>
  <div class="app-container">
    <div class="filter-container">
      <el-row type="flex" justify="space-between">
        <el-row type="flex" justify="end">
          <div>
            <el-input
              v-model="listQuery.user_id"
              placeholder="请输入会员ID"
              style="width: 200px"
              class="filter-item"
              clearable
            />
            <el-input
              v-model="listQuery.uuid"
              placeholder="请输入UUID"
              style="width: 200px"
              class="filter-item"
              clearable
            />
            <el-input
              v-model="listQuery.username"
              placeholder="请输入用户名称"
              style="width: 200px"
              class="filter-item"
              clearable
            />
            <el-input
              v-model="listQuery.last_name"
              placeholder="请输入姓"
              style="width: 200px"
              class="filter-item"
              clearable
            />
            <el-input
              v-model="listQuery.first_name"
              placeholder="请输入名"
              style="width: 200px"
              class="filter-item"
              clearable
            />
          </div>
          <div>
            优惠码状态
            <el-select
              v-model="listQuery.status"
              placeholder="状态"
              clearable
              style="width: 200px"
              class="filter-item"
            >
              <el-option label="未使用" value="not_use" />
              <el-option label="已使用" value="used" />
              <el-option label="已过期" value="expired" />
            </el-select>
          </div>

          <el-button
            size="small"
            class="filter-item"
            type="primary"
            icon="el-icon-search"
            @click="handleFilter"
            >搜索</el-button
          >
        </el-row>
      </el-row>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="ID" width="70">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="会员ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column label="UUID" min-width="130" align="center">
        <template slot-scope="scope">
          {{ scope.row.uuid }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户名称" width="120">
        <template slot-scope="scope">
          {{ scope.row.username || '' }}
        </template>
      </el-table-column>
      <el-table-column label="名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.first_name || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="姓" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.last_name || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="优惠码" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.code }}
        </template>
      </el-table-column>

      <el-table-column align="center" label="状态" min-width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 'used'" type="success"
            >已使用</el-tag
          >
          <el-tag v-else-if="scope.row.status == 'not_use'" type="warning"
            >未使用</el-tag
          >
          <el-tag v-else type="danger">已过期</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="兑换时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
      <!--      <el-table-column-->
      <!--        label="操作"-->
      <!--        align="center"-->
      <!--        min-width="230"-->
      <!--        class-name="small-padding fixed-width"-->
      <!--      >-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-button type="warning" @click="edit(scope.row)"> 修改 </el-button>-->
      <!--          <el-button type="primary" @click="pass(scope.row.id)">-->
      <!--            兑换详情-->
      <!--          </el-button>-->
      <!--          <el-button type="primary" @click="changeStatus(scope.row)">-->
      <!--            {{ Number(scope.row.is_on) == 1 ? '下架' : '上架' }}-->
      <!--          </el-button>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="驳回"
      :visible.sync="rejectModalVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      width="512px"
    >
      <el-form
        ref="rejectForm"
        :model="rejectForm"
        :rules="rejectRules"
        label-width="0px"
      >
        <el-form-item prop="reason">
          <el-input
            type="textarea"
            placeholder="驳回理由"
            :rows="4"
            v-model="rejectForm.reason"
          ></el-input>
        </el-form-item>
        <el-row type="flex" justify="end">
          <el-button @click="rejectModalVisible = false">取消</el-button>
          <el-button type="primary" @click="reject('rejectForm')"
            >确认</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      rejectModalVisible: false,
      rejectRules: {
        reason: [
          { required: true, message: '请填写驳回理由', trigger: 'blur' },
        ],
      },
      rejectForm: {
        id: '',
        reason: '',
      },
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        title: '',
        is_on: '',
      },
    }
  },
  created() {
    this.listQuery.coupon_id = this.$route.query.id
    this.getList()
  },
  watch: {
    rejectModalVisible() {
      this.rejectForm = {
        ...this.rejectForm,
        reason: '',
      }
    },
  },
  methods: {
    changeStatus(row) {
      let str
      if (Number(row.is_on) == 1) {
        str = '是否确认下架?'
      } else {
        str = '是否确认上架?'
      }
      this.$confirm(str, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/coupon/changeStatus',
            method: 'post',
            data: {
              id: row.id,
              is_on: row.is_on == 1 ? 0 : 1,
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/coupon/exchangeLogs',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    add(val) {
      this.$router.push('/operation/edit')
    },
    edit(val) {
      this.$router.push('/operation/edit?id=' + val.id)
    },
    createuser() {
      this.$router.push('/USER/createuser')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
